var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1243 2689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yelllow_bg",
    "data-name": "yelllow bg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1183.26,380.27V26.14L68.28,47.13v341.04c159.66-111.33,353.82-176.63,563.23-176.63s394.3,62.22,551.75,168.74Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1182.26,2637.49l1-336.72c-157.45,106.52-347.33,168.74-551.75,168.74s-403.56-65.3-563.23-176.63v343.62l1113.98,1Z",
    fill: "#f3b144",
    strokeWidth: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "red_bg_copy",
    "data-name": "red bg copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1183.26,380.27V26.14L68.28,47.13v341.04c159.66-111.33,353.82-176.63,563.23-176.63s394.3,62.22,551.75,168.74Z",
    fill: "#de423d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1182.26,2637.49l1-336.72c-157.45,106.52-347.33,168.74-551.75,168.74s-403.56-65.3-563.23-176.63v343.62l1113.98,1Z",
    fill: "#de423d",
    strokeWidth: 0
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "green_bg_copy_4",
    "data-name": "green bg copy 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1183.26,380.27V26.14L68.28,47.13v341.04c159.66-111.33,353.82-176.63,563.23-176.63s394.3,62.22,551.75,168.74Z",
    fill: "#4ba656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1182.26,2637.49l1-336.72c-157.45,106.52-347.33,168.74-551.75,168.74s-403.56-65.3-563.23-176.63v343.62l1113.98,1Z",
    fill: "#4ba656",
    strokeWidth: 0
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "boxes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Option1-green",
    x: 87.01,
    y: 1553.96,
    width: 1077.51,
    height: 186.3,
    rx: 54.19,
    ry: 54.19,
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "answer-Option1-green",
    x: 130,
    y: 1647.11,
    fontFamily: "SFComicScript",
    fontSize: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Option2-green",
    x: 87.01,
    y: 1773.24,
    width: 1077.51,
    height: 186.3,
    rx: 54.19,
    ry: 54.19,
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "answer-Option2-green",
    x: 130,
    y: 1866.39,
    fontFamily: "SFComicScript",
    fontSize: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Option3-green",
    x: 87.01,
    y: 1992.53,
    width: 1077.51,
    height: 186.3,
    rx: 54.19,
    ry: 54.19,
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "answer-Option3-green",
    x: 130,
    y: 2085.68,
    fontFamily: "SFComicScript",
    fontSize: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "picture_puzzle-green",
    x: 145.49,
    y: 388.17,
    width: 961.81,
    height: 526.47,
    rx: 8.35,
    ry: 8.35,
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "question-green",
    x: 144.87,
    y: 1035.5,
    width: 961.81,
    height: 266.17,
    rx: 5.94,
    ry: 5.94,
    fill: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("text", {
    id: "question-text-green",
    x: 144.87,
    y: 1035.5,
    fontFamily: "SFComicScript",
    fontSize: 40,
    fill: "black"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.28,
    y: 57.65,
    width: 1114.98,
    height: 2567.82,
    rx: 117.38,
    ry: 117.38,
    fill: "none",
    stroke: "#020202",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(145.49 2573) scale(1.19 1)",
    fill: "#fcfafc",
    fontFamily: "SFComicScript, 'SF Comic Script'",
    fontSize: 108.68
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "-.04em"
  }, "Wi"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.58,
    y: 0,
    letterSpacing: "-.02em"
  }, "se "), /*#__PURE__*/React.createElement("tspan", {
    x: 212.13,
    y: 0,
    letterSpacing: "-.14em"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 257.94,
    y: 0,
    letterSpacing: "-.04em"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 300.24,
    y: 0,
    letterSpacing: "-.02em"
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 351.34,
    y: 0,
    letterSpacing: "-.08em"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 382.03,
    y: 0,
    letterSpacing: "-.02em"
  }, "ete")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m854.51,2359.85c0,26.67,21.62,48.28,48.28,48.28s48.28-21.62,48.28-48.28c0-6.24-1.2-12.2-3.35-17.68,6.41,4.45,10.66,7.84,10.66,7.84v-.26l1.45,2.21,20,47.33.15-.23.26.4,21.51-49.67c.49-.39,6.22-4.92,14.24-10.27-4.44,7.93-6.99,17.07-6.99,26.81,0,30.34,24.6,54.94,54.94,54.94s54.94-24.6,54.94-54.94c0-13.31-4.74-25.52-12.62-35.03,3.54,1.29,5.68,2.17,5.68,2.17,0,0-15.45-30.62-55.12-30.62-36.35,0-61.25,37.18-61.25,37.18h-31.19c-1.78-2.59-26.15-37.01-61.13-37.01-39.67,0-55.12,30.62-55.12,30.62,0,0,8.35-3.43,19.34-6.7-8.04,8.62-12.96,20.19-12.96,32.9Zm189.05-12.27c10.36,0,18.76,8.4,18.76,18.76s-8.4,18.76-18.76,18.76-18.76-8.4-18.76-18.76,8.4-18.76,18.76-18.76Zm0,41.26c12.43,0,22.5-10.07,22.5-22.5s-10.08-22.5-22.5-22.5c-.77,0-1.54.04-2.3.12,2.21-.69,4.55-1.06,6.98-1.06,12.95,0,23.45,10.5,23.45,23.45s-10.5,23.45-23.45,23.45c-2.43,0-4.78-.37-6.98-1.06.75.08,1.52.12,2.3.12Zm4.69,5.63c15.54,0,28.13-12.59,28.13-28.13s-12.59-28.13-28.13-28.13c-.97,0-1.93.05-2.87.14,2.76-.86,5.69-1.32,8.73-1.32,16.19,0,29.31,13.12,29.31,29.31s-13.12,29.31-29.31,29.31c-3.04,0-5.97-.46-8.73-1.32.94.1,1.9.14,2.87.14Zm5.86,7.03c19.42,0,35.16-15.74,35.16-35.16s-15.74-35.16-35.16-35.16c-1.21,0-2.41.06-3.59.18,3.45-1.07,7.11-1.65,10.91-1.65,20.23,0,36.63,16.4,36.63,36.63s-16.4,36.63-36.63,36.63c-3.8,0-7.47-.58-10.91-1.65,1.18.12,2.38.18,3.59.18Zm55.63-35.16c0,25.29-20.5,45.79-45.79,45.79-13.62,0-25.85-5.95-34.24-15.39,8,8.35,19.25,13.55,31.73,13.55,24.27,0,43.95-19.68,43.95-43.95s-19.68-43.95-43.95-43.95c-12.47,0-23.73,5.21-31.73,13.55,6.98-7.85,16.61-13.29,27.5-14.9,6.88-.44,15.08.72,23,2.49,17.26,6.56,29.53,23.25,29.53,42.81Zm-206.94,33.76c-22.23,0-40.24-18.02-40.24-40.24,0-17.46,11.12-32.31,26.66-37.89,4.81-.69,9.49-1.02,13.68-.75.17.01.35.04.52.05-20.59.84-37.03,17.79-37.03,38.59s17.29,38.63,38.63,38.63c10.96,0,20.85-4.57,27.88-11.91-7.37,8.3-18.12,13.53-30.09,13.53Zm34.31-38.56c-.84,8.31-7.86,14.8-16.4,14.8-9.1,0-16.48-7.38-16.48-16.48s7.38-16.48,16.48-16.48c8.53,0,15.55,6.49,16.4,14.8.05.56.09,1.12.09,1.69s-.04,1.13-.09,1.69Zm-16.4-21.46c-10.92,0-19.78,8.85-19.78,19.78s8.85,19.78,19.78,19.78c.68,0,1.35-.03,2.02-.1-1.94.6-4,.93-6.14.93-11.38,0-20.6-9.23-20.6-20.6s9.23-20.6,20.6-20.6c2.14,0,4.2.33,6.14.93-.66-.07-1.34-.1-2.02-.1Zm-4.12-4.94c-13.65,0-24.72,11.07-24.72,24.72s11.07,24.72,24.72,24.72c.85,0,1.69-.04,2.52-.13-2.42.76-5,1.16-7.67,1.16-14.22,0-25.76-11.53-25.76-25.76s11.53-25.76,25.76-25.76c2.67,0,5.25.41,7.67,1.16-.83-.08-1.67-.13-2.52-.13Zm-5.15-6.18c-17.07,0-30.9,13.83-30.9,30.9s13.83,30.9,30.9,30.9c1.06,0,2.12-.05,3.15-.16-3.03.94-6.25,1.45-9.59,1.45-17.78,0-32.2-14.41-32.2-32.2s14.41-32.2,32.2-32.2c3.34,0,6.56.51,9.59,1.45-1.04-.1-2.09-.16-3.15-.16Zm21.44,4.19c-.33-.34-.66-.68-1.01-1.01.05.03.1.06.15.08.29.31.58.61.86.93Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m986.27,2312.69l89.45-80.74-87.1,12.94c-.85-4.01-3.77-7.11-7.47-8.34,2.94-3.4,6.74-6.64,11.25-7.99,12.75-3.82,27.12,6.73,42.99.41,15.88-6.31,19.92-24.46,19.92-24.46l-5.62-2.82s-6.1,17.92-16.8,21.67c-10.07,3.53-25.52-2.74-39.74-1,11.19-4.32,26.08.5,38.74-8.65l-3.8-4.82c-9.46,6.26-27.51,3.26-41.24,9.82-7.07,3.37-11.02,10.89-13.2,17.4-.18.27-.35.54-.52.81-4.34,1.89-7.14,6.38-6.71,11.27l-87.81,13.05,107.65,51.45Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1168.4,2467.97c-3.81-7.91-22.15-20.52-42.79-28.81,23.31.47,47.85,14.8,40.31,4.94-7.86-10.28-55.76-24.11-86.54-21.25l-.11-.86-6.54.83.12.95c-.17.03-.33.07-.49.1l-.97-.07s-31.78-1.8-37.01-5.26c-5.24-3.46-13.27-5.76-13.27-5.76,0,0-.02.02-.05.06-.8-.69-1.57-1.38-2.26-2.09-11.83-12.19-18.16-31.24-18.16-31.24l-20.5,44.91-22.53-44.91s-.36,12.64-12.17,26.04c-1.87,2.12-3.66,4.41-5.7,6.65-13.05,1.17-33.98,8.42-44.06,10.14l-.22-1.76-7.67.97.4,3.16c-8.02-.1-15.48-.27-17.88-.38-31.15-1.44-48.36-56.28-49.14-39.51-.38,8.28,8.63,26.4,21.61,42.79-20.76-6.45-38.6-22.06-33.6-11.68,3.81,7.91,22.15,20.52,42.79,28.81-23.31-.47-47.85-14.8-40.31-4.94,8.11,10.61,51.31,25.05,81.1,20.97l.48,3.81,7.67-.97-.3-2.38c.91-.19,1.9-.47,2.95-.84.44,1.47.89,2.95,1.37,4.42,2.69,14.91,8.86,28.9,18.04,40.22-.98.92-1.89,2.08-2.72,3.5-2.6,4.46-6.23,9.64-6.57,10-.49.51-.94.99-1.37,1.46-.09-.29-.18-.58-.3-.86-2.98-7.35-7.36-12.5-9.77-11.52-2.41.98-1.95,7.73,1.03,15.07,1.44,3.55,1.51,7.16,1.47,9.83-1.17.96-2.5,1.7-4.15,2.26-1.63-2.52-3.98-3.88-5.49-3.05-1.18.64-1.52,2.43-1.03,4.48-.72.17-1.36.36-1.94.55-1.59-2.06-3.64-3.09-5-2.35-1.24.68-1.55,2.62-.95,4.81-1.73.23-3.74-.86-8.96-5.03-22.57-18.05-34.1,7.41-34.1,7.41l-.53.49-.35-.16c-3.75-1.71-5.61.86-7.31,4.61l-1.18,3.2c-1.71,3.75-1.52,4.25,2.23,5.96l92.59,42.17c3.75,1.71,4.97-1.32,6.68-5.07,1.71-3.75,3.35-6.99-.4-8.7l-.64-.29c4.79-3.15,5.4-4.97,8.48-11.73,4.79-10.52,2.81-15.58,2-21.96-.2-1.54-.37-1.37-.32-3.15,0,0-.02-.03-.07-.1.68-.65,1.29-1.4,1.79-2.29,0,0,3.53-5.21,7.76-10.73,1.65-2.14,3.04-3.7,4.01-5.09,6.65,2,13.83,3.09,21.5,3.09,10.76,0,20.63-2.73,29.55-7.35,1.03,1.55,2.71,3.18,4.78,5.61,4.51,5.3,8.3,10.32,8.3,10.32.55.86,1.2,1.58,1.91,2.2-.04.06-.07.1-.07.1.14,1.78-.05,1.62-.16,3.17-.49,6.41-2.21,11.56,3.11,21.83,3.42,6.6,4.11,8.38,9.06,11.28l-.63.33c-3.66,1.9-1.86,5.05.03,8.71,1.9,3.66,3.26,6.62,6.92,4.73l90.35-46.78c3.66-1.9,3.82-2.4,1.93-6.06l-1.34-3.14c-1.9-3.66-3.88-6.13-7.54-4.24l-.34.18-.55-.46s-12.8-24.85-34.43-5.68c-5,4.43-6.95,5.62-8.69,5.48.5-2.22.08-4.14-1.19-4.75-1.4-.67-3.39.46-4.87,2.6-.59-.16-1.24-.32-1.97-.46.39-2.07-.04-3.84-1.25-4.42-1.55-.75-3.83.72-5.33,3.33-1.67-.48-3.04-1.15-4.26-2.05-.18-2.67-.29-6.28.97-9.9,2.61-7.49,2.73-14.25.27-15.11-2.46-.86-6.57,4.52-9.18,12-.1.29-.18.58-.25.88-.45-.45-.93-.9-1.44-1.39-.36-.34-4.24-5.33-7.07-9.66-1.85-2.84-4.02-4.54-6.36-5.38,7.7-9.97,13.91-21.06,18.55-31.76,2.09,2.99,15.37.08,19.94-1.03l.25,1.99,6.54-.83-.7-5.55c10.86-.56,20.83-1.08,23.12-.98,31.15,1.44,48.36,56.28,49.14,39.51.38-8.28-8.63-26.4-21.61-42.79,20.76,6.45,38.6,22.06,33.6,11.68Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 12
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 301.22,
    cy: 2317.98,
    r: 51.09,
    fill: "#fccf13",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.36,
    cy: 2358.59,
    r: 51.09,
    fill: "#8c8a89",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635.53,
    cy: 2391.34,
    r: 51.09,
    fill: "#cc6b52",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m359.33,2319.12c0,32.28-26.17,58.44-58.44,58.44s-58.44-26.17-58.44-58.44,26.17-58.44,58.44-58.44,58.44,26.17,58.44,58.44Zm-58.44-48.71c-26.9,0-48.71,21.81-48.71,48.71s21.81,48.71,48.71,48.71,48.71-21.81,48.71-48.71-21.81-48.71-48.71-48.71Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.21,2343.72s-6.2,2.2-11.96,0c-5.76-2.21-8.91-7.99-8.91-7.99,0,0,6.2-2.2,11.96,0,5.76,2.21,8.91,7.99,8.91,7.99Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.07,2344.63s-4.31-.08-6.87-2.79c-2.55-2.71-2.38-7.02-2.38-7.02,0,0,4.31.08,6.87,2.79,2.55,2.71,2.38,7.02,2.38,7.02Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.9,2317s-2.32-.38-3.49-2.05c-1.17-1.66-.74-3.98-.74-3.98,0,0,2.32.38,3.49,2.05s.74,3.98.74,3.98Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.3,2330.32s-4.14-1.22-5.89-4.51c-1.75-3.29-.45-7.4-.45-7.4,0,0,4.14,1.22,5.89,4.51,1.75,3.29.45,7.4.45,7.4Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.44,2343.65s6.2,2.2,11.96,0c5.76-2.21,8.91-7.99,8.91-7.99,0,0-6.2-2.2-11.96,0-5.76,2.21-8.91,7.99-8.91,7.99Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.57,2344.56s4.31-.08,6.87-2.79c2.55-2.71,2.38-7.02,2.38-7.02,0,0-4.31.08-6.87,2.79-2.55,2.71-2.38,7.02-2.38,7.02Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.75,2316.93s2.32-.38,3.49-2.05c1.17-1.66.74-3.98.74-3.98,0,0-2.32.38-3.49,2.05-1.17,1.66-.74,3.98-.74,3.98Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.34,2330.25s4.14-1.22,5.89-4.51c1.75-3.29.45-7.4.45-7.4,0,0-4.14,1.22-5.89,4.51-1.75,3.29-.45,7.4-.45,7.4Z",
    fill: "#866f2b",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.82,
    cy: 2312.78,
    r: 12.92,
    fill: "#866f2b",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m528.8,2359.36c0,32.28-26.17,58.44-58.44,58.44s-58.44-26.17-58.44-58.44,26.17-58.44,58.44-58.44,58.44,26.17,58.44,58.44Zm-58.44-48.71c-26.9,0-48.71,21.81-48.71,48.71s21.81,48.71,48.71,48.71,48.71-21.81,48.71-48.71-21.81-48.71-48.71-48.71Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m455.68,2383.97s-6.2,2.2-11.96,0-8.91-7.99-8.91-7.99c0,0,6.2-2.2,11.96,0,5.76,2.21,8.91,7.99,8.91,7.99Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.55,2384.88s-4.31-.08-6.87-2.79c-2.55-2.71-2.38-7.02-2.38-7.02,0,0,4.31.08,6.87,2.79,2.55,2.71,2.38,7.02,2.38,7.02Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m434.37,2357.25s-2.32-.38-3.49-2.05c-1.17-1.66-.74-3.98-.74-3.98,0,0,2.32.38,3.49,2.05,1.17,1.66.74,3.98.74,3.98Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.78,2370.56s-4.14-1.22-5.89-4.51c-1.75-3.29-.45-7.4-.45-7.4,0,0,4.14,1.22,5.89,4.51s.45,7.4.45,7.4Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.91,2383.9s6.2,2.2,11.96,0c5.76-2.21,8.91-7.99,8.91-7.99,0,0-6.2-2.2-11.96,0-5.76,2.21-8.91,7.99-8.91,7.99Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.05,2384.81s4.31-.08,6.87-2.79c2.55-2.71,2.38-7.02,2.38-7.02,0,0-4.31.08-6.87,2.79-2.55,2.71-2.38,7.02-2.38,7.02Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m504.22,2357.18s2.32-.38,3.49-2.05c1.17-1.66.74-3.98.74-3.98,0,0-2.32.38-3.49,2.05-1.17,1.66-.74,3.98-.74,3.98Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m493.81,2370.49s4.14-1.22,5.89-4.51c1.75-3.29.45-7.4.45-7.4,0,0-4.14,1.22-5.89,4.51-1.75,3.29-.45,7.4-.45,7.4Z",
    fill: "#424041",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.3,
    cy: 2353.03,
    r: 12.92,
    fill: "#424041",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m693.29,2392.04c0,32.28-26.17,58.44-58.44,58.44s-58.44-26.17-58.44-58.44,26.17-58.44,58.44-58.44,58.44,26.17,58.44,58.44Zm-58.44-48.71c-26.9,0-48.71,21.81-48.71,48.71s21.81,48.71,48.71,48.71,48.71-21.81,48.71-48.71-21.81-48.71-48.71-48.71Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620.17,2416.65s-6.2,2.2-11.96,0c-5.76-2.21-8.91-7.99-8.91-7.99,0,0,6.2-2.2,11.96,0,5.76,2.21,8.91,7.99,8.91,7.99Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.03,2417.56s-4.31-.08-6.87-2.79c-2.55-2.71-2.38-7.02-2.38-7.02,0,0,4.31.08,6.87,2.79,2.55,2.71,2.38,7.02,2.38,7.02Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.86,2389.93s-2.32-.38-3.49-2.05c-1.17-1.66-.74-3.98-.74-3.98,0,0,2.32.38,3.49,2.05,1.17,1.66.74,3.98.74,3.98Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.27,2403.24s-4.14-1.22-5.89-4.51c-1.75-3.29-.45-7.4-.45-7.4,0,0,4.14,1.22,5.89,4.51,1.75,3.29.45,7.4.45,7.4Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.4,2416.58s6.2,2.2,11.96,0c5.76-2.21,8.91-7.99,8.91-7.99,0,0-6.2-2.2-11.96,0-5.76,2.21-8.91,7.99-8.91,7.99Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.54,2417.49s4.31-.08,6.87-2.79,2.38-7.02,2.38-7.02c0,0-4.31.08-6.87,2.79-2.55,2.71-2.38,7.02-2.38,7.02Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.71,2389.86s2.32-.38,3.49-2.05.74-3.98.74-3.98c0,0-2.32.38-3.49,2.05-1.17,1.66-.74,3.98-.74,3.98Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m658.3,2403.17s4.14-1.22,5.89-4.51c1.75-3.29.45-7.4.45-7.4,0,0-4.14,1.22-5.89,4.51-1.75,3.29-.45,7.4-.45,7.4Z",
    fill: "#80351f",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 633.78,
    cy: 2385.71,
    r: 12.92,
    fill: "#80351f",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "home_wiseathlete"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1118.88,2365.85c0,30.34-24.6,54.94-54.94,54.94s-54.94-24.6-54.94-54.94,24.6-54.94,54.94-54.94,54.94,24.6,54.94,54.94Zm-54.94-45.79c-25.29,0-45.79,20.5-45.79,45.79s20.5,45.79,45.79,45.79,45.79-20.5,45.79-45.79-20.5-45.79-45.79-45.79Z",
    fill: "#3d79b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1089.27,2365.85c0,19.42-15.74,35.16-35.16,35.16s-35.16-15.74-35.16-35.16,15.74-35.16,35.16-35.16,35.16,15.74,35.16,35.16Zm-35.16-29.31c-16.19,0-29.31,13.12-29.31,29.31s13.12,29.31,29.31,29.31,29.31-13.12,29.31-29.31-13.12-29.31-29.31-29.31Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1105.38,2365.85c0,24.27-19.68,43.95-43.95,43.95s-43.95-19.68-43.95-43.95,19.68-43.95,43.95-43.95,43.95,19.68,43.95,43.95Zm-43.95-36.63c-20.23,0-36.63,16.4-36.63,36.63s16.4,36.63,36.63,36.63,36.63-16.4,36.63-36.63-16.4-36.63-36.63-36.63Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1076.37,2365.85c0,15.54-12.59,28.13-28.13,28.13s-28.13-12.59-28.13-28.13,12.59-28.13,28.13-28.13,28.13,12.59,28.13,28.13Zm-28.13-23.45c-12.95,0-23.45,10.5-23.45,23.45s10.5,23.45,23.45,23.45,23.45-10.5,23.45-23.45-10.5-23.45-23.45-23.45Z",
    fill: "#4ba656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066.06,2365.85c0,12.43-10.07,22.5-22.5,22.5s-22.5-10.07-22.5-22.5,10.07-22.5,22.5-22.5,22.5,10.07,22.5,22.5Zm-22.5-18.76c-10.36,0-18.76,8.4-18.76,18.76s8.4,18.76,18.76,18.76,18.76-8.4,18.76-18.76-8.4-18.76-18.76-18.76Z",
    fill: "#de423d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.79,2311.08c26.67,0,48.28,21.62,48.28,48.28,0,26.67-21.62,48.28-48.28,48.28-26.67,0-48.28-21.62-48.28-48.28,0-26.67,21.62-48.28,48.28-48.28Zm-40.24,48.28c0,22.23,18.02,40.24,40.24,40.24,22.23,0,40.24-18.02,40.24-40.24,0-22.23-18.02-40.24-40.24-40.24-22.23,0-40.24,18.02-40.24,40.24Z",
    fill: "#3d79b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m911.43,2328.46c17.07,0,30.9,13.83,30.9,30.9,0,17.07-13.83,30.9-30.9,30.9-17.07,0-30.9-13.83-30.9-30.9,0-17.07,13.83-30.9,30.9-30.9Zm-25.76,30.9c0,14.22,11.53,25.76,25.76,25.76s25.76-11.53,25.76-25.76c0-14.22-11.53-25.76-25.76-25.76s-25.76,11.53-25.76,25.76Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m904.99,2320.74c21.33,0,38.63,17.29,38.63,38.63,0,21.33-17.29,38.63-38.63,38.63-21.33,0-38.63-17.29-38.63-38.63,0-21.33,17.29-38.63,38.63-38.63Zm-32.2,38.63c0,17.78,14.41,32.2,32.2,32.2,17.78,0,32.2-14.41,32.2-32.2,0-17.78-14.41-32.2-32.2-32.2-17.78,0-32.2,14.41-32.2,32.2Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m916.58,2334.64c13.65,0,24.72,11.07,24.72,24.72s-11.07,24.72-24.72,24.72c-13.65,0-24.72-11.07-24.72-24.72,0-13.65,11.07-24.72,24.72-24.72Zm-20.6,24.72c0,11.38,9.23,20.6,20.6,20.6,11.38,0,20.6-9.23,20.6-20.6,0-11.38-9.23-20.6-20.6-20.6-11.38,0-20.6,9.23-20.6,20.6Z",
    fill: "#4ba656",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m920.7,2339.59c10.92,0,19.78,8.85,19.78,19.78,0,10.92-8.85,19.78-19.78,19.78-10.92,0-19.78-8.85-19.78-19.78,0-10.92,8.85-19.78,19.78-19.78Zm-16.48,19.78c0,9.1,7.38,16.48,16.48,16.48,9.1,0,16.48-7.38,16.48-16.48,0-9.1-7.38-16.48-16.48-16.48-9.1,0-16.48,7.38-16.48,16.48Z",
    fill: "#de423d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1056.82,2302.37c-36.35,0-61.25,37.18-61.25,37.18h-31.19c-1.78-2.59-26.15-37.01-61.13-37.01-39.67,0-55.12,30.62-55.12,30.62,0,0,33.58-13.81,54.75-12.44,21.17,1.37,55.5,28.8,55.5,28.8v-.26l1.45,2.21,20,47.33.15-.23.26.4,21.51-49.67c1.22-.97,34.66-27.41,55.44-28.76,21.17-1.37,54.75,12.44,54.75,12.44,0,0-15.45-30.62-55.12-30.62Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m988.62,2244.41c-.85-4.01-3.77-7.11-7.47-8.34,2.94-3.4,6.74-6.64,11.25-7.99,12.75-3.82,27.12,6.73,42.99.41,15.88-6.31,19.92-24.46,19.92-24.46l-5.62-2.82s-6.1,17.92-16.8,21.67c-10.07,3.53-25.52-2.74-39.74-1,11.19-4.32,26.08.5,38.74-8.65l-3.8-4.82c-9.46,6.26-27.51,3.26-41.24,9.82-7.07,3.37-11.02,10.89-13.2,17.4-.18.27-.35.54-.52.81-4.34,1.89-7.14,6.38-6.71,11.27l-87.81,13.05,107.65,51.45,89.45-80.74-87.1,12.94Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1021.73,2468.82c-1.3-11.39-2.79-21.31-4.46-29.75l-15.24-1c3.21,15.82,4.66,37.9,4.66,37.9,0,0-19.83-26.2-20.26-28.69l-6.39.45-6.39-.45c-.43,2.49-17.62,24.04-20.26,28.69-.1-9.45,1.45-22.08,4.66-37.9l-15.24,1c-1.67,8.44-3.16,18.35-4.46,29.75-1.27,10.11-2.01,18.5-2.21,25.17,1.64-.2,3.39-.36,5.27-.48,4.75-.3,13.48-.28,18.06.04,5.68-9.35,20.58-22.62,20.58-22.62,0,0,14.9,13.27,20.58,22.62,4.58-.32,13.31-.33,18.06-.04,1.87.12,3.63.28,5.27.48-.2-6.67-.94-15.06-2.21-25.17Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1168.4,2467.48c-3.81-7.91-22.15-20.52-42.79-28.81,23.31.47,47.85,14.8,40.31,4.94-8.55-11.19-64.51-26.58-94.23-20.09-5.12.49-10.31,1.14-14.98,2.19-13.04,0-29.75-7.01-37.93-15.45-11.83-12.19-18.16-31.24-18.16-31.24l-20.5,44.91-22.53-44.91s-.36,12.64-12.17,26.04c-7.42,8.41-13.68,19.68-39.02,18.73-.99-.24-1.83-.04-2.53.5-11.22.08-29.55-.27-33.59-.45-31.15-1.44-48.36-56.28-49.14-39.51-.38,8.28,8.63,26.4,21.61,42.79-20.76-6.45-38.6-22.06-33.6-11.68,3.81,7.91,22.15,20.52,42.79,28.81-23.31-.47-47.85-14.8-40.31-4.94,8.55,11.19,56.1,26.63,85.82,20.14,2.23-.21,4.24-.58,6.08-1.07.79,2.75,1.61,4.19,2.24,3.36,8.93,29.5,33.14,66.31,73.65,66.33,37.91.02,59-36.18,72.43-67.08.82,1.18,49.96-2.16,55.41-1.91,31.15,1.44,48.36,56.28,49.14,39.51.38-8.28-8.63-26.4-21.61-42.79,20.76,6.45,38.6,22.06,33.6,11.68Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m946.06,2544.06s3.53-5.21,7.76-10.73c4.24-5.52,6.88-7.14,4.59-12.2-3.19-7.07-27.68-31.13-38.17-13.12-2.6,4.46-6.23,9.64-6.57,10-10.5,11-7.48,11.31-4.99,16.28s12.12,8.21,16.18,11.86c4.05,3.65,16.63,5.92,21.2-2.11Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m934.83,2583.59l-.64-.29c4.79-3.15,5.4-4.97,8.48-11.73,4.79-10.52,2.81-15.58,2-21.96-.2-1.54-.37-1.37-.32-3.15,0,0-1.48-2.12-4.8-3.56-2.8-1.22-6.88-3.22-12.38-6.48-6.67-3.95-11.82-5.38-14.71-16.37-.11-.47-.26-.94-.45-1.41-2.98-7.35-7.36-12.5-9.77-11.52-2.41.98-1.95,7.73,1.03,15.07,1.44,3.55,1.51,7.16,1.47,9.83-1.17.96-2.5,1.7-4.15,2.26-1.63-2.52-3.98-3.88-5.49-3.05-1.18.64-1.52,2.43-1.03,4.48-.72.17-1.36.36-1.94.55-1.59-2.06-3.64-3.09-5-2.35-1.24.68-1.55,2.62-.95,4.81-1.73.23-3.74-.86-8.96-5.03-22.57-18.05-34.1,7.41-34.1,7.41l-.53.49-.35-.16c-3.75-1.71-5.61.86-7.31,4.61l-1.18,3.2c-1.71,3.75-1.52,4.25,2.23,5.96l92.59,42.17c3.75,1.71,4.97-1.32,6.68-5.07,1.71-3.75,3.35-6.99-.4-8.7Z",
    fill: "#3d79b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861.22,2551.32l65.47,29.82s8.43-.48-1.59-5.04c-10.02-4.56-63.88-24.77-63.88-24.77Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1021.96,2539.91s-3.78-5.02-8.3-10.32c-4.51-5.3-7.23-6.78-5.2-11.95,2.83-7.22,26.07-32.48,37.46-15.02,2.82,4.33,6.7,9.32,7.07,9.66,11.04,10.46,8.05,10.91,5.8,16.01-2.24,5.1-11.69,8.81-15.56,12.66-3.87,3.85-16.31,6.75-21.28-1.03Z",
    fill: "#231f20",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1035.17,2578.81l.63-.33c-4.95-2.91-5.64-4.69-9.06-11.28-5.32-10.27-3.59-15.42-3.11-21.83.12-1.55.31-1.38.16-3.17,0,0,1.37-2.19,4.61-3.8,2.74-1.36,6.7-3.57,12.04-7.1,6.46-4.28,11.53-5.97,13.86-17.09.09-.48.21-.96.38-1.43,2.61-7.49,6.72-12.86,9.18-12,2.46.86,2.34,7.62-.27,15.11-1.26,3.62-1.15,7.23-.97,9.9,1.21.9,2.59,1.57,4.26,2.05,1.5-2.6,3.78-4.07,5.33-3.33,1.21.58,1.64,2.35,1.25,4.42.72.14,1.38.29,1.97.46,1.48-2.14,3.47-3.27,4.87-2.6,1.27.61,1.68,2.54,1.19,4.75,1.74.14,3.69-1.04,8.69-5.48,21.63-19.17,34.43,5.68,34.43,5.68l.55.46.34-.18c3.66-1.9,5.64.57,7.54,4.24l1.34,3.14c1.9,3.66,1.74,4.16-1.93,6.06l-90.35,46.78c-3.66,1.9-5.03-1.06-6.92-4.73-1.9-3.66-3.7-6.81-.03-8.71Z",
    fill: "#3d79b7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1107.05,2542.88l-63.89,33.08s-8.44-.06,1.33-5.12c9.78-5.06,62.55-27.96,62.55-27.96Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1079.27,2421.51l-6.54.83.14,1.09-1.48-.11s-31.78-1.8-37.01-5.26c-5.24-3.46-13.27-5.76-13.27-5.76,0,0-14.9,16.04-41.06,16.81-26.16.78-37.66-19.03-39.01-17.49-12.92.77-34.93,8.46-45.36,10.24l-.22-1.76-7.67.97,5.45,43.02,7.67-.97-.3-2.38c.91-.19,1.9-.47,2.95-.84.44,1.47.89,2.95,1.37,4.42,6.51,36.16,33.48,67.01,74.42,67.02,38.31.02,65.22-34.63,78.78-65.86,2.09,2.99,15.37.08,19.94-1.03l.25,1.99,6.54-.83-5.58-44.1Z",
    fill: "#de423d",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1018.55,2475.55c-1.29-11.27-2.76-21.09-4.42-29.44l-15.09-.99c3.18,15.66,4.62,37.51,4.62,37.51,0,0-19.62-25.93-20.05-28.39l-6.32.44-6.32-.44c-.43,2.46-17.44,23.79-20.05,28.39-.1-9.35,1.44-21.85,4.62-37.51l-15.09.99c-1.66,8.35-3.13,18.16-4.42,29.44-1.26,10.01-1.99,18.31-2.18,24.91,1.62-.2,3.36-.35,5.21-.47,4.7-.29,13.34-.28,17.87.04,5.62-9.25,20.37-22.38,20.37-22.38,0,0,14.74,13.13,20.37,22.38,4.53-.32,13.17-.33,17.87-.04,1.85.12,3.59.28,5.21.47-.2-6.6-.93-14.9-2.18-24.91Z",
    fill: "#f3b144",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1023.99,2414.34s-9.02,10.33-17.39,15.15c-9.83,5.66-37.88,7.06-50.14,0-8.37-4.82-18.96-16.34-18.96-16.34l-2.77,2.32s10.48,12.17,19.69,16.97c14.44,7.52,39.76,7.52,54.21,0,9.22-4.8,19.58-15.94,19.58-15.94l-4.22-2.16Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1075.06 2424.13 1079.85 2463.28 1081.99 2462.72 1077.51 2423.47 1075.06 2424.13",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "889.69 2422.53 894.48 2461.68 896.62 2461.12 892.14 2421.87 889.69 2422.53",
    fill: "#fff",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPage);
export default __webpack_public_path__ + "static/media/GreenPage.60f5fc57d2071d994b49a495b2079758.svg";
export { ForwardRef as ReactComponent };